<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12">
        <custom-data-table :tableName="tableName" :header="headers" :items="items" :loading="loading" visibleCreate @stored="stored" :visibleStore="updatePermission">
          <template v-slot:status="{ item }">
            <v-chip v-if="item.status === statuses.draughting.value" color="grey" text-color="white">
              <v-avatar left><v-icon>mdi-pencil-circle</v-icon></v-avatar>{{ statuses.draughting.name }}
            </v-chip>
            <v-chip v-if="item.status === statuses.pending.value" color="warning" text-color="white">
              <v-avatar left><v-icon>mdi-circle-slice-8</v-icon></v-avatar>{{ statuses.pending.name }}
            </v-chip>
            <v-chip v-if="item.status === statuses.sendBack.value" color="error" text-color="white">
              <v-avatar left><v-icon>mdi-close-circle</v-icon></v-avatar>{{ statuses.sendBack.name }}
            </v-chip>
            <v-chip v-if="item.status === statuses.approved.value" color="success" text-color="white">
              <v-avatar left><v-icon>mdi-check-circle</v-icon></v-avatar>{{ statuses.approved.name }}
            </v-chip>
          </template>
          <template v-slot:holiday_flg="{ item }">
            <v-avatar v-if="item.holiday_flg" left><v-icon>mdi-check</v-icon></v-avatar>
          </template>
          <template v-slot:action="{ item }">
            <div v-if="(item.holiday_flg)">
              <v-btn class="mr-2" depressed small color="error" @click.stop="showholidayDeleteDialog(item.worker_date)">削除</v-btn>
            </div>
            <div v-else>
              <v-btn v-if="(item.status === statuses.pending.value || item.status === statuses.approved.value)" class="mr-2" depressed small color="info" :to="{ name: 'WorkerDailyReportInfo', params: { worker_date: item.worker_date, user_id: user.user_id } }">閲覧</v-btn>
              <v-btn v-if="updatePermission && (item.status === statuses.draughting.value || item.status === statuses.sendBack.value)" class="mr-2" depressed small color="primary" :to="{ name: 'WorkerDailyReportEdit', params: { worker_date: item.worker_date, user_id: user.user_id } }">編集</v-btn>
            </div>
          </template>
        </custom-data-table>
      </v-col>
    </v-row>
    <!-- 新規作成ボタン押下後に表示されるダイアログ -->
    <v-row justify="center">
      <v-dialog v-model="reportDateDialogDrawer" persistent :max-width="500">
        <v-card>
          <v-container>
            <v-card-text>
              <v-row justify="center">
                <!-- カレンダー -->
                <v-date-picker ref="picker" v-model="workerDate" :max="today" :allowed-dates="allowedDates" @change="disableData" locale="ja_jp"></v-date-picker>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-btn depressed color="error" @click="holidayRegistration()" :disabled="reportDateDisabled">休暇日登録</v-btn>
              <v-spacer></v-spacer>
              <v-btn depressed @click.stop="reportDateDialogDrawer=!reportDateDialogDrawer" color="grey lighten-1">キャンセル</v-btn>
              <v-btn depressed @click.stop="create" color="success" :disabled="reportDateDisabled">作業日報作成</v-btn>
            </v-card-actions>
          </v-container>
        </v-card>
      </v-dialog>
    </v-row>
  <!-- 休暇日削除ダイアログ -->
  <v-row justify="center">
    <v-dialog v-model="holidayDeleteDialogDrawer" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">休暇日削除</v-card-title>
          <v-card-text><h4>{{this.holiday_date}}の休暇日登録を削除しますか？</h4></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed color="grey lighten-1" @click.stop="holidayDeleteDialogDrawer = false">キャンセル</v-btn>
          <v-btn depressed color="error" @click.stop="deleteholiday()">削除</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  </v-container>
</template>

<script>
import { useAppInsights } from '@/plugins/application-insights';
import statusList from "@/helpers/const";
import WorkerDailyReportApi from "@/api/worker-daily-report-api";
import WorkerDailyReportSubApi from "@/api/worker-daily-report-sub-api";
import CustomDataTable from "@/components/custom_ui/CustomDataTable";

export default {
  name: "WorkerDailyReport",
  components: {
    CustomDataTable,
  },
  props: ["user"],
  data: () => ({
    //カレンダー表示範囲
    today: new Date().toISOString().substr(0, 10),
    workerDate: new Date().toISOString().substr(0, 10),
    // 共通コンポーネント: データテーブル関連
    loading: false,
    reportDateDialogDrawer:false,
    holidayDeleteDialogDrawer: false,
    tableName: "作業日報",
    headers: [
      { text: "ステータス", value: "status"},
      { text: "休暇日", value: "holiday_flg"},
      { text: "日付", value: "worker_date"},
      { text: "アクション", value: "action"},
    ],
    items: [],
    statuses: {
      draughting: { name: "下書き", value: 0 },
      pending: { name: "申請中", value: 1 },
      sendBack: { name: "差し戻し", value: 2 },
      approved: { name: "承認済み", value: 3 }
    },
    workerDateList:[],
    reportDateDisabled: false,
    // 権限
    updatePermission: true,
    holiday_date : ""
  }),
  created() {
    this.initialize();
  },
  methods: {
    //カレンダー日付範囲
    allowedDates (val) { return this.workerDateList.indexOf(val) === -1},
    //日付フォーマット
    parseDate (date) {
      if (!date) return null;
      const [year,month, day] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    disableData () {
      this.reportDateDisabled =  !this.allowedDates(this.workerDate);
    },

    isLoading() {
      this.loading = !this.loading;
      this.$emit("loading", this.loading);
    },
    initialize() {
      this.isLoading();
      if (this.user.role_id == 0) {
        this.updatePermission = this.user.permission_config.CTSG00012.update;
      }
      this.workerDateList = [];
      this.workerDailyReportApi = new WorkerDailyReportApi();
      const promise = this.workerDailyReportApi.list();
      promise.then(response => {
        this.items = response.data.body.worker_daily_report_list;
        for(var item of this.items){
          this.workerDateList.push(
            this.parseDate(item.worker_date)
          );
        }
      }).catch(error => {
        useAppInsights().trackException({exception: error});
        if (error.response) {
          if (error.response.data.status == statusList.status.authError) {
            this.$emit('logoutConform');
          } else if (error.response.data.status == statusList.status.entityError) {
            this.$emit("error",error.response.data.message);
            this.$router.push({ name: "Dashboard" })
          } else {
            this.$emit("error",error.response.data.message);
          }
        } else {
          this.$emit("error","サーバーエラーが発生しました。");
        }
      }).finally(() => {
        this.disableData();
        this.isLoading();
      });
    },
    //新規作成ボタン押下時
    stored() {
      this.reportDateDialogDrawer = true;
    },
    // 休暇日削除」ボタン押下時
    showholidayDeleteDialog(date) {
      this.holiday_date = date;
      this.holidayDeleteDialogDrawer = true;
    },
    //作業日報作成ボタン押下時
    create() {
      this.$router.push({ name: 'WorkerDailyReportStore', params: { worker_date: this.formatDate(this.workerDate), user_id: this.user.user_id } });
    },
    holidayRegistration() {
      this.isLoading();

      const params = {
        user_id: this.user.user_id,
        construction_id: 0,
        status: 3,
        worker_date: this.workerDate,
        report: JSON.stringify({}),
        holiday_flg: true
      };

      this.workerDailyReportSubApi = new WorkerDailyReportSubApi();
      const promise = this.workerDailyReportSubApi.store({ params: params });
      promise.then(response => {
        this.reportDateDialogDrawer = false;
        this.$emit('success', response.data.message);
      }).catch(error => {
        useAppInsights().trackException({exception: error});
        if (error.response) {
          if (error.response.data.status == statusList.status.authError) {
            this.$emit('logoutConform');
          } else if (error.response.data.status == statusList.status.entityError) {
            this.$emit("error",error.response.data.message);
            this.$router.push({ name: "Dashboard" })
          } else {
            this.$emit("error",error.response.data.message);
          }
        } else {
          this.$emit("error","サーバーエラーが発生しました。");
        }
      }).finally(() => {
        this.isLoading();
        this.initialize();
      });
    },
    deleteholiday() {
      this.isLoading();
      this.workerDailyReportApi = new WorkerDailyReportApi();
      const promise = this.workerDailyReportApi.delete(this.holiday_date);
      promise.then(response => {
        this.holidayDeleteDialogDrawer = false;
        this.$emit('success', response.data.message);
      }).catch(error => {
        useAppInsights().trackException({exception: error});
        if (error.response) {
          if (error.response.data.status == statusList.status.authError) {
            this.$emit('logoutConform');
          } else if (error.response.data.status == statusList.status.entityError) {
            this.$emit("error",error.response.data.message);
            this.$router.push({ name: "Dashboard" })
          } else {
            this.$emit("error",error.response.data.message);
          }
        } else {
          this.$emit("error","サーバーエラーが発生しました。");
        }
      }).finally(() => {
        this.isLoading();
        this.initialize();
      });
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${year}/${month}/${day}`;
    },
    dialogCancel() {
      this.reportDateDialogDrawer = false;
    },
  }
};
</script>
